export default __webpack_public_path__ + "static/media/handphone_2_without_words_mobile.786f319c.png";